/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EamEfaDashboardInfo
 */
export interface EamEfaDashboardInfo {
    /**
     * 
     * @type {string}
     * @memberof EamEfaDashboardInfo
     */
    url?: string;
}

/**
 * Check if a given object implements the EamEfaDashboardInfo interface.
 */
export function instanceOfEamEfaDashboardInfo(value: object): value is EamEfaDashboardInfo {
    return true;
}

export function EamEfaDashboardInfoFromJSON(json: any): EamEfaDashboardInfo {
    return EamEfaDashboardInfoFromJSONTyped(json, false);
}

export function EamEfaDashboardInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EamEfaDashboardInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function EamEfaDashboardInfoToJSON(json: any): EamEfaDashboardInfo {
    return EamEfaDashboardInfoToJSONTyped(json, false);
}

export function EamEfaDashboardInfoToJSONTyped(value?: EamEfaDashboardInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

